"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function TheHeartOfLittleAcorns() {
  const {
    ref: portraitRef,
    isVisible: portraitVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const {
    ref: eyebrowRef,
    isVisible: eyebrowVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const {
    ref: headlineRef,
    isVisible: headlineVisible
  } = useRevealOnScroll<HTMLHeadingElement>({
    threshold: 0.15
  });
  const {
    ref: paragraphRef,
    isVisible: paragraphVisible
  } = useRevealOnScroll<HTMLParagraphElement>({
    threshold: 0.15
  });
  const {
    ref: signatureRef,
    isVisible: signatureVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  return <section data-section-id="1186" id="the-heart-of-little-acorns" className="bg-primary text-primary-foreground relative overflow-hidden py-32 md:py-48">
      {}
      <div className="pointer-events-none absolute inset-0 opacity-[0.06] mix-blend-overlay" style={{
      backgroundImage: "url(\"data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='200' height='200'><filter id='n'><feTurbulence type='fractalNoise' baseFrequency='0.9' numOctaves='2'/></filter><rect width='100%' height='100%' filter='url(%23n)' opacity='0.8'/></svg>\")"
    }} aria-hidden="true" />

      <div className="container mx-auto max-w-[1320px] px-6 md:px-10 lg:px-16">
        <div className="grid grid-cols-1 gap-16 lg:grid-cols-12 lg:gap-12">
          {}
          <div ref={portraitRef} className="lg:col-span-7 lg:pl-6" style={{
          transform: portraitVisible ? "translateY(0)" : "translateY(24px)",
          opacity: portraitVisible ? 1 : 0,
          transition: "transform 720ms cubic-bezier(.2,.7,.2,1), opacity 720ms cubic-bezier(.2,.7,.2,1)"
        }}>
            <div className="relative">
              {}
              <div className="relative p-3 md:p-4 rounded-lg" style={{
              backgroundColor: "hsl(40 33% 96%)",
              boxShadow: "12px 12px 0px 0px hsl(28 35% 45%)"
            }}>
                <div className="relative overflow-hidden rounded-md">
                  <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1722029/img/founders_story_2005.png" alt="Cathie and Mimi in the original classroom setting, 2005" className="block h-auto w-full object-cover" style={{
                  aspectRatio: "4 / 5"
                }} loading="lazy" decoding="async" />
                </div>
              </div>

              {}
              <p className="mt-6 font-mono text-xs uppercase tracking-[0.18em] md:text-[0.8125rem]" style={{
              color: "hsl(40 33% 96% / 0.7)"
            }}>
                — Our Founders · Est. 2005
              </p>
            </div>
          </div>

          {}
          <div className="relative lg:col-span-5">
            {}
            <div aria-hidden="true" className="pointer-events-none absolute -top-8 left-0 select-none font-default leading-none" style={{
            fontSize: "clamp(11rem, 22vw, 26rem)",
            color: "transparent",
            WebkitTextStroke: "2px hsl(40 33% 96%)",
            opacity: 0.09,
            fontWeight: 600,
            transform: portraitVisible ? "translateY(-6%)" : "translateY(0)",
            transition: "transform 1200ms cubic-bezier(.2,.7,.2,1)"
          }}>
              01
            </div>

            <div className="relative">
              {}
              <div ref={eyebrowRef} className="font-mono text-xs uppercase tracking-[0.18em] md:text-[0.8125rem]" style={{
              color: "hsl(40 33% 96% / 0.7)",
              opacity: eyebrowVisible ? 1 : 0,
              transform: eyebrowVisible ? "translateY(0)" : "translateY(24px)",
              transition: "transform 720ms cubic-bezier(.2,.7,.2,1), opacity 720ms cubic-bezier(.2,.7,.2,1)"
            }}>
                — OUR STORY · LITTLE ACORNS
              </div>

              {}
              <h2 ref={headlineRef} className="mt-6 font-default font-semibold leading-[1.02]" style={{
              fontSize: "clamp(2.25rem, 5vw, 4.25rem)",
              letterSpacing: "-0.02em",
              color: "hsl(40 33% 96%)",
              opacity: headlineVisible ? 1 : 0,
              transform: headlineVisible ? "translateY(0)" : "translateY(24px)",
              transition: "transform 720ms cubic-bezier(.2,.7,.2,1) 90ms, opacity 720ms cubic-bezier(.2,.7,.2,1) 90ms"
            }}>
                The Mighty{" "}
                <em className="font-serif italic" style={{
                color: "hsl(45 90% 45%)",
                opacity: headlineVisible ? 1 : 0,
                transform: headlineVisible ? "translateY(0)" : "translateY(8px)",
                transition: "transform 600ms cubic-bezier(.2,.7,.2,1) 290ms, opacity 600ms cubic-bezier(.2,.7,.2,1) 290ms",
                display: "inline-block"
              }}>
                  Oak
                </em>
              </h2>

              {}
              <p ref={paragraphRef} className="mt-8 max-w-[42ch] font-default text-base leading-[1.65] md:text-lg" style={{
              color: "hsl(40 33% 96% / 0.9)",
              opacity: paragraphVisible ? 1 : 0,
              transform: paragraphVisible ? "translateY(0)" : "translateY(24px)",
              transition: "transform 720ms cubic-bezier(.2,.7,.2,1) 180ms, opacity 720ms cubic-bezier(.2,.7,.2,1) 180ms"
            }}>
                Since 2005, Cathie and Mimi have nurtured a community where the Montessori method meets the warmth of home. We believe that every child is a seed of infinite potential, and our role is to provide the rich soil, sunlight, and space they need to grow into their own unique, mighty selves.
              </p>

              {}
              <div ref={signatureRef} className="mt-12" style={{
              opacity: signatureVisible ? 1 : 0,
              transform: signatureVisible ? "translateY(0)" : "translateY(24px)",
              transition: "transform 720ms cubic-bezier(.2,.7,.2,1) 270ms, opacity 720ms cubic-bezier(.2,.7,.2,1) 270ms"
            }}>
                <div className="inline-block">
                  <div className="font-serif italic" style={{
                  fontSize: "1.5rem",
                  color: "hsl(40 33% 96%)",
                  letterSpacing: "-0.01em"
                }}>
                    Cathie & Mimi
                  </div>
                  <svg className="mt-1 h-3 w-44" viewBox="0 0 180 12" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                    <path d="M2 7 C 30 2, 60 11, 90 6 S 150 3, 178 8" stroke="hsl(40 33% 96%)" strokeWidth="1.5" strokeLinecap="round" fill="none" />
                  </svg>
                  <div className="mt-2 font-mono text-[0.7rem] uppercase tracking-[0.18em]" style={{
                  color: "hsl(40 33% 96% / 0.6)"
                }}>
                    Founders · Educators
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}